export enum KiwiInstitutionChannel {
  CREATE = 'kiwiInstitution:create',
  EDIT = 'kiwiInstitution:edit',
  DELETE = 'kiwiInstitution:delete',
}
